








import Vue from 'vue'
import { mapState } from 'vuex'

import AlertVar from '@/components/organisms/c/AlertVar.vue'
import Header from '@/components/organisms/c/Header.vue'
export default Vue.extend({
  components: { Header, AlertVar },
  computed: {
    ...mapState('app', ['belongStores']),
  },
  methods: {
    onSelectStoreCode(storeCode: string) {
      this.$store.dispatch('app/updateSelectedStoreCode', {
        storeCode: storeCode,
      })
    },
  },
})
